export type EnvName =
    | 'local_pwa_to_dev'
    | 'local_pwa_bff_to_dev'
    | 'development'
    | 'production'
    | 'staging'
    | 'staging-test'
    | 'development-test'
    | 'production-test'
    | 'sandbox1'
    | 'sandbox2'
    | 'sandbox2ngrok'
    | 'sandbox3'
    | 'sandbox4'
    | 'sandbox5'
    | 'sandbox6';

export interface EnvProps {
    orgId: string;
    shortCode: string;
    host: string;
    bffBaseUrl: string;
    bffApiKey: string;
    bffApiHost?: string;
    originUrl: string;
    clientId: string;
    cidr: string[];
    /**
     * If the environment is using a SLAS private client, we must configure here, in such case, we need to also have
     * PWA_KIT_SLAS_CLIENT_SECRET environment set.
     */
    isSLASClientPrivate?: boolean;
}

export type Envs = {
    [key in EnvName]: EnvProps;
};

const development = {
    orgId: 'f_ecom_bcjl_dev',
    shortCode: 'xveiy6nj',
    host: 'dev.surlatable.com',
    bffApiKey: 'Jk8hdQoz2uKjWyTPKYAE2qUnzr3ZgPXWD129tFi0',
    bffApiHost: 'api-test2.surlatable.com',
    bffBaseUrl: 'https://dev.surlatable.com/mobify/proxy/slt/sfcc-bff-dev',
    originUrl: 'https://dev.surlatable.com',
    clientId: '5a8cf24c-1d25-4736-ac00-fc8b1f08727e',
    cidr: ['0.0.0.0/0', '::1'],
};

export const environments: Envs = {
    local_pwa_to_dev: {
        ...development,
        bffBaseUrl: 'http://localhost:8000/mobify/proxy/slt/sfcc-bff-dev',
    },
    local_pwa_bff_to_dev: {
        ...development,
        bffBaseUrl: 'http://localhost:1337',
        originUrl: 'http://localhost:8000',
    },
    development,
    production: {
        orgId: 'f_ecom_bcjl_prd',
        shortCode: 'xveiy6nj',
        host: 'www.surlatable.com',
        bffApiHost: 'api-prodv2.surlatable.com',
        bffBaseUrl: 'https://www.surlatable.com/mobify/proxy/slt/sfcc-bff',
        bffApiKey: '2T4VHkByol3DxuIqjou0h4p7F6xzX23i8cG0Y48W',
        originUrl: 'https://www.surlatable.com',
        clientId: '8f9edd13-01c5-4ad8-9179-b1139f5ac940',
        cidr: [
            '38.23.87.142/32', // Yorty
            '69.132.49.104/32', // Gabe
            '66.23.93.113/32', // Meenakshi
            '136.49.130.44/32', // Mokshika
            '177.215.85.164/32', // kaue
            '99.122.250.179/32', // Alpesh
            '179.217.205.118/32', // Diego
            '10.112.5.0/24', // AWS Test - Non-Secure Cluster us-west-2a
            '10.112.6.0/24', // AWS Test - Non-Secure Cluster us-west-2b
        ],
    },
    staging: {
        orgId: 'f_ecom_bcjl_stg',
        shortCode: 'xveiy6nj',
        host: 'staging.surlatable.com',
        bffApiHost: 'api-test2.surlatable.com',
        bffBaseUrl: 'https://staging.surlatable.com/mobify/proxy/slt/sfcc-bff',
        bffApiKey: 'bdJ7j7Cr4Z4iZnVSpIR7466Z8EHA7CJh3MIkFdjq',
        originUrl: 'https://staging.surlatable.com',
        clientId: '6b1bb777-e752-4748-ad48-57d200a001fe',
        cidr: ['0.0.0.0/0', '::1'],
    },
    'staging-test': {
        orgId: 'f_ecom_bfsg_stg',
        shortCode: 'lcvmg5oc',
        host: 'staging-test.surlatable.com',
        bffBaseUrl: 'https://staging-test.surlatable.com/mobify/proxy/slt/sfcc-bff-staging-test',
        bffApiKey: 'bdJ7j7Cr4Z4iZnVSpIR7466Z8EHA7CJh3MIkFdjq',
        bffApiHost: 'api-test2.surlatable.com',
        originUrl: 'https://staging-test.surlatable.com',
        clientId: 'a8a75ea4-894f-46f2-a832-cb89c783024d',
        cidr: ['0.0.0.0/0', '::1'],
    },
    'development-test': {
        orgId: 'f_ecom_bfsg_dev',
        shortCode: 'lcvmg5oc',
        host: 'dev-test.surlatable.com',
        bffBaseUrl: 'https://dev-test.surlatable.com/mobify/proxy/slt/sfcc-bff-dev-test',
        bffApiKey: 'bdHFsgR9jI1cElJBb8SH056NSrP4mV0P8DZFDFQd',
        bffApiHost: 'api-test2.surlatable.com',
        originUrl: 'https://dev-test.surlatable.com',
        clientId: 'bb531561-0343-4bed-b194-8a1acb3cf454',
        cidr: ['0.0.0.0/0', '::1'],
    },
    'production-test': {
        orgId: 'f_ecom_bfsg_prd',
        shortCode: 'lcvmg5oc',
        host: 'production-test.surlatable.com',
        bffBaseUrl:
            'https://production-test.surlatable.com/mobify/proxy/slt/sfcc-bff-production-test',
        bffApiKey: '',
        bffApiHost: 'api-test2.surlatable.com',
        originUrl: 'https://production-test.surlatable.com',
        clientId: '1257a1b3-a7f3-486f-9a06-fc96d31b7f88',
        cidr: ['0.0.0.0/0', '::1'],
    },
    sandbox1: {
        orgId: 'f_ecom_bcjl_001',
        shortCode: 'xveiy6nj',
        host: 'bcjl-001.dx.commercecloud.salesforce.com',
        bffBaseUrl: 'http://localhost:1337',
        bffApiKey: '',
        originUrl: 'http://localhost:8000',
        clientId: 'cfe534b9-6040-40f5-a294-ebc030189d4e',
        cidr: ['0.0.0.0/0', '::1'],
    },
    sandbox2: {
        orgId: 'f_ecom_bcjl_002',
        shortCode: 'xveiy6nj',
        host: 'bcjl-002.dx.commercecloud.salesforce.com',
        bffBaseUrl: 'http://localhost:1337',
        bffApiKey: '',
        originUrl: 'http://localhost:8000',
        clientId: 'f1f42163-b8f9-4654-8124-8abbef675497',
        cidr: ['0.0.0.0/0', '::1'],
    },
    sandbox2ngrok: {
        orgId: 'f_ecom_bcjl_002',
        shortCode: 'xveiy6nj',
        host: 'bcjl-002.dx.commercecloud.salesforce.com',
        bffBaseUrl: 'https://slt-bff-yorty.ngrok.dev',
        bffApiKey: '',
        originUrl: 'https://slt-sandbox-yorty.ngrok.dev',
        clientId: 'f1f42163-b8f9-4654-8124-8abbef675497',
        cidr: ['0.0.0.0/0', '::1'],
    },
    sandbox3: {
        orgId: 'f_ecom_bcjl_003',
        shortCode: 'xveiy6nj',
        host: 'bcjl-003.dx.commercecloud.salesforce.com',
        bffBaseUrl: 'https://localhost:1337',
        bffApiKey: '',
        originUrl: 'https://localhost:8000',
        clientId: '7f760f82-d760-4488-8952-de85b1022a35',
        cidr: ['0.0.0.0/0', '::1'],
        isSLASClientPrivate: false,
    },
    sandbox4: {
        orgId: 'f_ecom_bcjl_004',
        shortCode: 'xveiy6nj',
        host: 'bcjl-004.dx.commercecloud.salesforce.com',
        bffBaseUrl: 'http://localhost:1337',
        bffApiKey: '',
        originUrl: 'http://localhost:8000',
        clientId: 'fab40cf6-186c-4115-869f-bf50ccb31d01',
        cidr: ['0.0.0.0/0', '::1'],
    },
    sandbox5: {
        orgId: 'f_ecom_bcjl_005',
        shortCode: 'xveiy6nj',
        host: 'bcjl-005.dx.commercecloud.salesforce.com',
        bffBaseUrl: 'http://localhost:1337',
        bffApiKey: '',
        originUrl: 'http://localhost:8000',
        clientId: 'b0fe0d94-6d69-4b00-9965-920615db0fee',
        cidr: ['0.0.0.0/0', '::1'],
    },
    sandbox6: {
        orgId: 'f_ecom_bcjl_006',
        shortCode: 'xveiy6nj',
        host: 'bcjl-006.dx.commercecloud.salesforce.com',
        bffBaseUrl: 'http://localhost:1337',
        bffApiKey: '',
        originUrl: 'http://localhost:8000',
        clientId: '874d2131-57ff-468b-b3a8-83f00cbbb0b8',
        cidr: ['0.0.0.0/0', '::1'],
    },
};
